import { render } from "./header-teacher-materials.vue?vue&type=template&id=080eb192&ts=true"
import script from "./header-teacher-materials.vue?vue&type=script&lang=ts"
export * from "./header-teacher-materials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__